import { makeConfigRef } from '../util.make-config-ref.js';
import { environment } from './util.environment.js';

function makeEnvironmentRef(getter) {
  const configRef = makeConfigRef(getter);
  environment.observe(() => {
    configRef.__update(getter());
  });
  return configRef;
}

export { makeEnvironmentRef };
//# sourceMappingURL=util.make-environment-ref.js.map
